import React, { memo } from 'react'

import authorization from 'live/services/authorization'

import { escalationWidth } from '../../../../../../../../../utils/constants'
import { StyledAddButtom } from './styles'
import i18n from 'live/services/i18n'

type IProps = {
    type: IType
    x: number
    y: number
    onAddRequest: (type: IType) => void
    customText?: string
    escalationLength: number
    opacity?: number
}
type IType = 'ESCALATIONBARRIER' | 'ESCALATIONFACTOR'

const AddButton: React.FC<IProps> = ({ type, x, y, onAddRequest, customText, escalationLength, opacity = 1 }) => {
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    return (
        <>
            {bowtieAdmin && (
                <g
                    transform={`translate(${x}, ${y})`}
                    cursor="pointer"
                    onClick={() => onAddRequest(type)}
                    opacity={opacity}
                >
                    <StyledAddButtom
                        x={10}
                        y={8}
                        width={escalationLength > 0 ? 24 : type === 'ESCALATIONFACTOR' ? escalationWidth - 20 : 85}
                        height={24}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <div>
                            <i className="far fa-plus" />
                            {escalationLength > 0 ? '' : customText ?? i18n(type)}
                        </div>
                    </StyledAddButtom>
                </g>
            )}
        </>
    )
}

export default memo(AddButton)
